import '../../resources/css/login/ModalAccountSetting.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Modal} from 'react-bootstrap';
import { closeAccountConfig, closeResetPwd } from '../../actions/login/index';
import { closeModal } from '../../actions';
import AccountSettingForm from './AccountSettingForm';

class ModalAccountForm extends Component {

  render() {
    const { modalStatus, closeModal } = this.props;
    let show = modalStatus === "accountForm";
    
    return (
      <Modal
        show={show}
        dialogClassName="modal-account-config-setting"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header >
          <Modal.Title>
            <label className='area-header-text'>Edit Account Settings</label>
            <span id="account-setting-form-close" className='icon-btn-close-n' onClick={()=>closeModal(null)}></span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={12}><AccountSettingForm></AccountSettingForm></Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    modalStatus:state.commonReducers.modalStatus,
  }
}

export default connect(
  mapStateToProps,
  { closeAccountConfig, closeResetPwd, closeModal }
)(ModalAccountForm)